import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';
import { MeasurementParameters, ChartData, TempChartDataResults } from './types';

/**
 * Retrieves list of user measurements
 *
 * @method getMeasurementsList
 * @memberof Measurement
 * @param  {number} patient_id - Patient user ID
 * @param  {MeasurementParameters} parameters - Data filter parameters
 * @returns {Promise<ChartData[]>} - List of filtered user measurement analytics
 */

export const getMeasurementsList = async (
  patient_id: number,
  parameters: MeasurementParameters
): Promise<ChartData[]> => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/analytics/measurements/${patient_id}`);
  const params = new URLSearchParams(url.search);

  parameters?.session && params.append('sessions', parameters.session);
  parameters?.date_range && params.append('date_range', parameters.date_range);

  return httpGet(`${url.href}?${params.toString()}`, {})
    .then((results) => {
      if (results?.data.success) {
        /* TODO: Fix this once results typo is fixed in backend */
        const measurementList = results.data.result.map((data: TempChartDataResults) => {
          return {
            ...data,
            measurement_id: data.measrement_id,
          };
        });

        return measurementList;
      }

      return;
    })
    .catch((error) => {
      throw new Error(`Error getting player measurement data ${error}`);
    });
};
